import React from 'react';
import { useNavigate } from '@tanstack/react-router';

import { isUserLoggedIn } from '../helpers/auth';

const LeaveResponseCTA: React.FC = () => {
  if (isUserLoggedIn()) return null;

  const nav = useNavigate();

  return (
    <div className="cta leave-response-cta wa-grid wa-gap-md">
      <wa-card>
        <h3>Leave a response</h3>
        <p>
          Create a free account to comment — it only takes a moment,<br />
          and you can start your own memory while you're here.
        </p>
        <div className="wa-cluster wa-gap-xs cta-buttons">
          <wa-button appearance="accent" onClick={() => nav({ to: '/signup' })}>
            Create free account
          </wa-button>
          <wa-button appearance="outlined" onClick={() => nav({ to: '/login', search: { redirect: window.location.href } })}>
            Sign in
          </wa-button>
        </div>
        <p className="cta-subtitle subtitle">
          Free forever · No credit card required
        </p>
      </wa-card>
    </div>
  );
}

export default LeaveResponseCTA;
